import React, { useState } from "react";
import {
  CloseButton,
  Button,
  OverlayTrigger,
  Tooltip,
  Table,
  Form
} from "react-bootstrap";

const FileUpload = ({
  onChange,
  maxFileSize,
  value,
  accept,
  maxFileCount
}) => {
  const [list, setList] = useState(value || []);

  const rerender = () => {
    setList(list.slice());
    onChange && onChange(list);
  };

  const handleUp = (e, i) => {
    const temp = list[i];
    list[i] = list[i - 1];
    list[i - 1] = temp;
    rerender();
  };

  const handleDown = (e, i) => {
    const temp = list[i];
    list[i] = list[i + 1];
    list[i + 1] = temp;
    rerender();
  };

  const handleDelete = (e, i) => {
    list.splice(i, 1);
    rerender();
  };

  const handleOnChange = (e) => {
    let files = e.currentTarget.files;
    if (files) {
      for (var i = 0; i < files.length; i++) {
        list.push(files[i]);
      }
      rerender();
    }
  };

  const renderTooltip = (props) => (
    <Tooltip {...props}>File exceeds maximum allowable size</Tooltip>
  );

  const validate = (file) => {
    if (maxFileSize && maxFileSize > 0 && file.size > maxFileSize) {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <span>{String.fromCharCode(9888)}</span>
        </OverlayTrigger>
      );
    }
  };

 

  const renderFileInput = () => {
    if (!(maxFileCount > 0) || list.length < maxFileCount) {
      return (
        <Form.Control type="file" onChange={handleOnChange} accept={accept} />
      );
    }
  };

  return (
    <>
     
      {renderFileInput()}
    </>
  );
};

export default FileUpload;
